module.exports = __webpack_public_path__ + "img/48.3d7f3f42.png";